module.exports = __webpack_public_path__ + "pc/img/work_list1.c8b519b7.jpg";